import { render, staticRenderFns } from "./inbdadd.vue?vue&type=template&id=235f64c3&scoped=true"
import script from "./inbdadd.vue?vue&type=script&lang=js"
export * from "./inbdadd.vue?vue&type=script&lang=js"
import style0 from "./inbdadd.vue?vue&type=style&index=0&id=235f64c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235f64c3",
  null
  
)

export default component.exports